//#region Functions Imports
import React, { useEffect } from 'react';
import { StyleSheet, FlatList, View, Pressable, Platform, useWindowDimensions, ActivityIndicator } from 'react-native';
import { Card } from 'react-native-paper';
import CustomProgressCircle from '../../../components/CustomProgressCircle/CustomProgressCircle';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../components/CustomInput';
import { useTranslation } from 'react-i18next';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { useSettingsContext } from '../../../hooks/useSettingsContext';
import { useAccount } from '../../../hooks/useAccount';
import { useTheme, useNavigation, useRoute } from '@react-navigation/native';
import * as Progress from 'react-native-progress';
import HomePageDashboard from '../../HomeShortcutsPage/HomePageDashboard';
import { useSafeAreaInsets } from "react-native-safe-area-context";
//#endregion

const PersonalLeaveBalancesScreen = (props) => {

  //#region State Definitions
  const { leaveAnalysis: leaveAnalysisProp, oasisParam } = useAccountContext();
  const leaveAnalysis = props.leaveAnalysis || leaveAnalysisProp || [];
  const { isAlphaMega } = useSettingsContext();
  const { t, i18n } = useTranslation();
  const { leaveAnalysisGet, isLoading } = useAccount();
  const { colors } = useTheme();
  const navigation = useNavigation();
  const { width, height } = useWindowDimensions();
  const styles = makeStyles(colors, props, width, height)
  const numColumns = width > 1200 ? 3 : width > 600 ? 2 : 1;
  const isHalfScreen = Platform.OS === "web" && width <= 900
  // const [expandedItems, setExpandedItems] = React.useState({});
  const route = useRoute();
  const insets = useSafeAreaInsets();
  const currentScreen = route.name;
  const isHRAdminEmplLeaveAnalysisScreen = props.isHRAdminEmplLeaveAnalysisScreen ?? (currentScreen === 'HRAdminEmplLeaveAnalysisScreen');
  //#endregion

  //#region API Calls
  /*const GetLeaveAnalysis = async () => {
    //leaveAnalysisGet().catch(console.error);
  }*/
  //#endregion

  const formatHoursWithEstimatedDays = (hoursValue, daysValue, showDays) => {
    if (hoursValue === undefined || hoursValue === null || hoursValue === '') return '';

    const hoursText = `${hoursValue} hours`;

    if (showDays && daysValue !== undefined && daysValue !== null && daysValue !== '') {
      return `${hoursText} (${daysValue})`;
    }

    return hoursText;
  };

  const formatDaysOnly = (daysValue, showDays) => {
    if (!showDays || daysValue === undefined || daysValue === null || daysValue === '') return '';
    return `(${daysValue})`;
  };

  //#region Listeners
  const ShowHideMenu = (item) => {
    const [showDetails, setShowDetails] = React.useState(props.ShowDetails || false);
    const isAnnualLeave = item.acodeDesc !== 'Accumulated';
    // const [editAllowance, setEditAllowance] = React.useState(String(item.yearlyAllowance ?? ''));
    const [editAllowance, setEditAllowance] = React.useState(String(item.allowance ?? ''));
    const [editBroughtForward, setEditBroughtForward] = React.useState(String(item.broughtforward ?? ''));
    const [editPaid, setEditPaid] = React.useState(String(item.paid ?? ''));

    // useEffect(() => { setEditAllowance(String(item.yearlyAllowance ?? '')); }, [item.yearlyAllowance]);
    useEffect(() => { setEditAllowance(String(item.allowance ?? '')); }, [item.allowance]);
    useEffect(() => { setEditBroughtForward(String(item.broughtforward ?? '')); }, [item.broughtforward]);
    useEffect(() => { setEditPaid(String(item.paid ?? '')); }, [item.paid]);

    useEffect(() => {
      if (!item.resetVersion) return;
      setEditAllowance(String(item.allowance ?? ''));
      setEditBroughtForward(String(item.broughtforward ?? ''));
      setEditPaid(String(item.paid ?? ''));
    }, [item.resetVersion]);

    const notifyChange = (allowance, broughtForward, paid) => {
      props.onBalanceChange?.(item, parseFloat(allowance) || 0, parseFloat(broughtForward) || 0, parseFloat(paid) || 0);
    };

    const onShowHidePress = () => {
      if (!props.isHRAdminEmplLeaveAnalysisScreen) return;
      setShowDetails((prev) => !prev);
    };

    // Recompute live display values from edit states
    const liveAllowance = parseFloat(editAllowance) || 0;
    const liveBroughtForward = parseFloat(editBroughtForward) || 0;
    const livePaid = parseFloat(editPaid) || 0;
    const liveTaken = item.taken ?? 0;
    const liveRemaining = liveAllowance + liveBroughtForward - liveTaken - livePaid - (item.broughtforwardExpired ?? 0);
    const liveTotalAllowance = (liveAllowance + liveBroughtForward - (item.broughtforwardExpired ?? 0)) || 0;
    const rawPercent = liveTotalAllowance !== 0 ? (liveRemaining * 100) / liveTotalAllowance : 100;
    const liveLeavePercent = Math.max(0, isFinite(rawPercent) ? rawPercent : 100);
    const showEstimatedDays = item.convertFromHoursToDays === true;

    const liveRemainingDisplay = formatHoursWithEstimatedDays(
      liveRemaining.toFixed(1),
      item.remaining_conv,
      showEstimatedDays
    );

    const liveAllowanceDisplay = formatHoursWithEstimatedDays(
      liveAllowance.toFixed(1),
      item.allowance_conv,
      showEstimatedDays
    );

    const liveTot = `${liveRemainingDisplay} / ${liveAllowanceDisplay}`;

    return oasisParam === undefined || oasisParam === null ? (
      <></>
    ) : (
      <View style={styles.showhide}>
        <Pressable
          onPress={props.isHRAdminEmplLeaveAnalysisScreen ? onShowHidePress : undefined}
          disabled={!props.isHRAdminEmplLeaveAnalysisScreen}
        >
          {/*Use live computed values */}
          {liveTotalAllowance !== 0 ? (
            <CustomLabel value={liveTot} type="AVAILABLEUSED" />
          ) : (
            <CustomLabel value={liveRemaining} type="AVAILABLEUSED" />
          )}
          <View style={styles.circleView}>
            {Platform.OS === "android" ? (
              <Progress.Circle
                animated={false}
                progress={liveLeavePercent.toFixed(0) / 100}
                size={(height * 10) / 100}
                borderWidth={1}
                textStyle={styles.circle}
                showsText={true}
                color={
                  item.acodeDesc === "Accumulated"
                    ? colors.buttons_primary
                    : item.colour.toLowerCase()
                }
              />
            ) : (
              <CustomProgressCircle
                percent={liveLeavePercent.toFixed(0)}
                bgRingWidth={15}
                progressRingWidth={15}
                radius={50}
                textFontSize={16}
                ringColor={
                  item.acodeDesc === "Accumulated"
                    ? colors.buttons_primary
                    : item.colour.toLowerCase()
                }
                textFontColor={colors.text_primary}
              />
            )}
          </View>

          {showDetails === true && (
            <View>
              <View style={styles.line} />
              <View style={styles.item}>
                <View style={styles.row}>
                  <CustomLabel
                    value={isAlphaMega ? t("common:CurrAllowanceEOY") + `:` : t("common:CurrAllowance") + `:`}
                    type="LEAVEDETAILSMAJOR"
                  />
                  <CustomLabel
                    value={formatHoursWithEstimatedDays(
                      (liveRemaining ?? 0).toFixed(1),
                      item.remaining_conv,
                      item.convertFromHoursToDays === true
                    )}
                    type="LEAVEDETAILSMINOR"
                  />
                </View>

                <View style={styles.line} />
              </View>
              <View style={styles.item}>
                <View style={styles.row}>
                  <CustomLabel value={t("common:LeaveTaken") + `:`} type="LEAVEDETAILSMAJOR" />

                  <CustomLabel
                    value={formatHoursWithEstimatedDays(
                      (item.taken ?? 0).toFixed(1),
                      item.taken_conv,
                      item.convertFromHoursToDays === true
                    )}
                    type="LEAVEDETAILSMINOR"
                  />
                </View>
                <View style={styles.line} />
              </View>
              <View style={styles.item}>
                <View style={styles.row}>
                  <CustomLabel value={t("common:YearlyAllowance") + `:`} type="LEAVEDETAILSMAJOR" />
                  {props.isHRAdminEmplLeaveAnalysisScreen && isAnnualLeave ? (
                    <View style={styles.row}>
                      <Pressable onPress={(e) => e.stopPropagation()}>
                        <View style={styles.input}>
                          <CustomInput
                            value={editAllowance}
                            setValue={(val) => {
                              const cleaned = val.replace(/[^0-9.]/g, '');
                              // Max 3 digits before decimal, 1 digit after
                              const match = cleaned.match(/^(\d{0,3})(\.\d?)?/);
                              const capped = match ? match[0] : '';
                              setEditAllowance(capped);
                              notifyChange(capped, editBroughtForward, editPaid);
                            }}
                            maxLen={5}
                            type="MAININPUT"
                            keyboardType="numeric"
                            editable={true}
                          />
                        </View>
                      </Pressable>

                      {item.convertFromHoursToDays === true && (
                        <View style={{margin: 0}}>
                        <CustomLabel
                          value={formatDaysOnly(item.allowance_conv, true)}
                          type="LEAVEDETAILSMINOR_NOMARGIN"
                        />
                        </View>
                      )}
                    </View>
                  ) : (
                    <CustomLabel
                      value={formatHoursWithEstimatedDays(
                        (item.allowance ?? 0).toFixed(1),
                        item.allowance_conv,
                        item.convertFromHoursToDays === true
                      )}
                      type="LEAVEDETAILSMINOR"
                    />
                  )}
                </View>
                <View style={styles.line} />
              </View>
              <View style={styles.item}>
                <View style={styles.row}>
                  <CustomLabel value={t("common:BroughtFoward") + `:`} type="LEAVEDETAILSMAJOR" />

                  {props.isHRAdminEmplLeaveAnalysisScreen && isAnnualLeave ? (
                    <View style={styles.row}>
                      <Pressable onPress={(e) => e.stopPropagation()}>
                        <View style={styles.input}>
                          <CustomInput
                            value={editBroughtForward}
                            setValue={(val) => {
                              const cleaned = val.replace(/[^0-9.]/g, '');
                              const match = cleaned.match(/^(\d{0,3})(\.\d?)?/);
                              const capped = match ? match[0] : '';
                              setEditBroughtForward(capped);
                              notifyChange(editAllowance, capped, editPaid);
                            }}
                            maxLen={5}
                            type="MAININPUT"
                            keyboardType="numeric"
                            editable={true}
                          />
                        </View>
                      </Pressable>

                      {item.convertFromHoursToDays === true && (
                        <CustomLabel
                          value={formatDaysOnly(item.broughtforward_conv, true)}
                          type="LEAVEDETAILSMINOR_NOMARGIN"
                        />
                      )}
                    </View>
                  ) : (
                    <CustomLabel
                      value={formatHoursWithEstimatedDays(
                        (item.broughtforward ?? 0).toFixed(1),
                        item.broughtforward_conv,
                        item.convertFromHoursToDays === true
                      )}
                      type="LEAVEDETAILSMINOR"
                    />
                  )}

                </View>
                <View style={styles.line} />
              </View>
              {!isAlphaMega && (
                <View style={styles.item}>
                  <View style={styles.row}>
                    <CustomLabel value={t("common:BroughtFowardExpired") + `:`} type="LEAVEDETAILSMAJOR" />

                    <CustomLabel
                      value={formatHoursWithEstimatedDays(
                        (item.broughtforwardExpired ?? 0).toFixed(1),
                        item.broughtforwardExpired_conv,
                        item.convertFromHoursToDays === true
                      )}
                      type="LEAVEDETAILSMINOR"
                    />
                  </View>
                  <View style={styles.line} />
                </View>
              )}
              {!isAlphaMega && (
                <View style={styles.item}>
                  <View style={styles.row}>
                    <CustomLabel value={t("common:Paid/Lost") + `:`} type="LEAVEDETAILSMAJOR" />

                    {props.isHRAdminEmplLeaveAnalysisScreen && isAnnualLeave ? (
                      <View style={styles.row}>
                        <Pressable onPress={(e) => e.stopPropagation()}>
                          <View style={styles.input}>
                            <CustomInput
                              value={editPaid}
                              setValue={(val) => {
                                const cleaned = val.replace(/[^0-9.]/g, '');
                                const match = cleaned.match(/^(\d{0,3})(\.\d?)?/);
                                const capped = match ? match[0] : '';
                                setEditPaid(capped);
                                notifyChange(editAllowance, editBroughtForward, capped);
                              }}
                              maxLen={5}
                              type="MAININPUT"
                              keyboardType="numeric"
                              editable={true}
                            />
                          </View>
                        </Pressable>

                        {item.convertFromHoursToDays === true && (
                          <CustomLabel
                            value={formatDaysOnly(item.paid_conv, true)}
                            type="LEAVEDETAILSMINOR_NOMARGIN"
                          />
                        )}
                      </View>
                    ) : (
                      <CustomLabel
                        value={formatHoursWithEstimatedDays(
                          (item.paid ?? 0).toFixed(1),
                          item.paid_conv,
                          item.convertFromHoursToDays === true
                        )}
                        type="LEAVEDETAILSMINOR"
                      />
                    )}

                  </View>
                  <View style={styles.line} />
                </View>
              )}
            </View>
          )}
        </Pressable>
      </View>
    );
  };
  //#endregion

  //#region UseEffects
  useEffect(() => {
    if (isHRAdminEmplLeaveAnalysisScreen) {
      navigation.setOptions({ title: "" }); // Hide title explicitly
    } else {
      navigation.setOptions({ title: t("navigate:BL") });
    }
  }, [navigation, isHRAdminEmplLeaveAnalysisScreen, t]);

  /*useEffect(() => {
    const onGetLeaveAnalysis = async () => {
      await GetLeaveAnalysis()
    }
    onGetLeaveAnalysis()
      .catch(console.error);
  }, [])*/

  useEffect(
    () => {
      // * No need to do anything here
    },
    [width, height]
  );
  //#endregion

  //#region Render Data
  const renderData = (item, index) => {
    const isSickLeave = (item.acodeDesc && item.acodeDesc.toLowerCase().includes('sick'))

    if (process.env.REACT_APP_CLIENT === 'atlas' && isSickLeave && !isHRAdminEmplLeaveAnalysisScreen) {
      return (<></>);
    }

    let type = 'Accumulated'
    if (isAlphaMega)
      type = 'ANNUAL LEAVE'
    // if (item.yearlyAllowance > 0 || item.acodeDesc === 'OVERTIME LEAVE') {
    if (item.allowance > 0 || item.acodeDesc === 'OVERTIME LEAVE') {
      if (props.AnnualLeaveOnly === true && (item.acodeDesc !== type)) {
        return (<></>)
      }
      else {
        if (isAlphaMega && item.acodeDesc === 'Accumulated')
          return (<></>)
        else
          return (
            <Card style={styles.cardstyle} >
              {!props.AnnualLeaveOnly === true && < Card.Title
                title={item.acodeDesc || item.analysisCode || t("common:LT")}
                titleStyle={styles.textMain}
                titleNumberOfLines={1}
              />}
              <Card.Content>
                <ShowHideMenu {...item} resetVersion={props.resetVersion} />
              </Card.Content >
              <Card.Actions>
              </Card.Actions>
            </Card >
          )
      }
    }
  }

  //#endregion
  return (
    <View style={[styles.mainView, { paddingBottom: Math.max(insets.bottom + 18, 40) }]}>
      {props.AnnualLeaveOnly !== true &&
        !isHRAdminEmplLeaveAnalysisScreen && (
          <CustomLabel value={t("navigate:BL")} type="MINORTITLE" />
        )}
      {Platform.OS === "web" && width > 500 ? (
        <FlatList
          key={`columns-${numColumns}`}
          numColumns={numColumns}
          columnWrapperStyle={
            numColumns > 1 ? { justifyContent: "flex-start" } : undefined
          }
          data={leaveAnalysis}
          contentContainerStyle={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent:
              Platform.OS === "web" && width < 1100 ? "flex-start" : "center",
          }}
          horizontal={false}
          showsHorizontalScrollIndicator={!props.AnnualLeaveOnly}
          persistentscrollbar={true}
          initialNumToRender={20}
          ListEmptyComponent={
            isLoading ? (
              <ActivityIndicator animating={true} color={colors.blue} />
            ) : (
              <CustomLabel value={t("common:emptyleave")} type="ASSM" />
            )
          }
          renderItem={({ item, index }) => {
            return renderData(item, index);
          }}
          keyExtractor={(item) => `${item.acodeDesc}`}
        />
      ) : (
        <FlatList
          data={leaveAnalysis}
          renderItem={({ item, index }) => {
            return renderData(item, index);
          }}
          initialNumToRender={20}
          keyExtractor={(item, index) =>
            item.analysisID ? `${item.analysisID}` : `${index}`
          }
        />
      )}
      {leaveAnalysis?.some(item => item.convertFromHoursToDays === true) && process.env.REACT_APP_CLIENT === 'atlas' && (
        <View style={[{ marginTop: 10, alignItems: props.AnnualLeaveOnly === true ? 'center' : 'flex-start' }]}>
          <CustomLabel
            value={t("common:estimatedNote")}
            type="AVAILABLEUSED"
          />
        </View>
      )}
    </View>
  );
};

const makeStyles = (colors, props, width, height) => StyleSheet.create({
  mainView: {
    flex: 1,
    marginTop: "1%",
    // marginLeft: '1%',
    //marginRight: '1%',
    justifyContent: 'center',
    paddingLeft: Platform.OS === 'web' ? 20 : 5
  },
  circle: {
    color: colors.text_primary,
    fontWeight: 'bold',
  },
  cardstyle: {
    flex: 1,
    width: '98%',
    alignSelf: 'flex-start',
    padding: (Platform.OS === 'web' && width > 500) ? 0 : 10,
    margin: Platform.OS === 'web' ? 15 : 1,
    marginHorizontal: Platform.OS === 'web' ? 10 : 0,
    marginVertical: Platform.OS === 'web' ? 15 : 5,
    marginRight: Platform.OS === 'web' ? 15 : 5,
    borderRadius: 35,
    borderWidth: (Platform.OS === 'web' && width > 500) ? (props.AnnualLeaveOnly === true ? 0 : 2) : 0,
    borderColor: colors.dropdown_border,
    elevation: Platform.OS === 'web' ? 5 : 3,
    shadowColor: (Platform.OS === 'web') ? colors.card_line : 'transparent',
    shadowOffset: (Platform.OS === 'web') ? { width: 0, height: 0 } : { width: 0, height: 0 },
    shadowOpacity: 0.0,
    shadowRadius: (Platform.OS === 'web') ? 5 : 2,
    paddingBottom: 10,
    backgroundColor: props.AnnualLeaveOnly === true ? 'transparent' : colors.background_card
  },
  showhide: {
    width: (Platform.OS === 'web' && width > 500) ? width * 0.34 : '100%',
    marginLeft: (Platform.OS === 'web' && width > 500) ? 0 : Platform.OS === 'android' ? 0 : 10,
    maxWidth: Platform.OS === 'web' ? 420 : '100%',
  },
  line: {
    borderBottomColor: colors.buttons_primary,
    borderBottomWidth: StyleSheet.hairlineWidth,
    marginTop: "5%",
    marginBottom: "5%",
  },
  item: {
    flex: 1,
  },
  input: {
    width: 100,
    minWidth: 100,
    maxWidth: 100,
  },
  column: {
    justifyContent: "center",
  },

  circleView: {
    paddingTop: '5%',
    marginVertical: 10,
    alignItems: "center",
  },
  scroll: {
    flex: 1,
    width: '100%',
    height: '100%',
  },
  textMain: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.text_primary,
    justifyContent: 'center'
  },
  row: {
    flexDirection: "row",
    alignItems: 'left',
    width: '100%',
  },

});

export default PersonalLeaveBalancesScreen;